import styled from 'styled-components'
import { Plain } from 'components/button'

export const QuickSelectButton = styled(Plain).attrs({ className: 'constructive small' })`
    margin-top: 16px;
`